import React from 'react';
import styled from 'styled-components/macro';
import { School } from '../utils/data_types';
import { THEME_COLORS } from '../utils/theme';
import { SectionHeader, SectionBannerPink, HeaderFont } from './styles';

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 2vw auto;
  max-width: 75vw;
`;

const TopSchoolData = styled.div`
  display: flex;
  text-align: center;
  margin: max(10px, 0.5vw) 2vw;
  background-color: ${THEME_COLORS.headerWhite};
  border-radius: 10px;
  padding: 1vw 1.5vw;
`;

const Data = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0 1vw;
`;

interface Props {
  schoolData: Array<School>;
}

export const TopSchools: React.FC<Props> = props => {
  let data = props.schoolData;
  return (
    <SectionBannerPink>
      <SectionHeader color={THEME_COLORS.headerWhite}>Top Schools</SectionHeader>
      <Container>
        {data.map(school => (
          <TopSchoolData>
            <Data style={{ color: THEME_COLORS.brandPink }}>
              <HeaderFont>{school.schoolName}</HeaderFont>
            </Data>
            <Data>
              <HeaderFont>{school.totalSchool}%</HeaderFont>
            </Data>
          </TopSchoolData>
        ))}
      </Container>
    </SectionBannerPink>
  );
};
